// extracted by mini-css-extract-plugin
export default {"omniboxFocusOverlay":"withPersistedOmniboxSurface_omniboxFocusOverlay__VGr29","visible":"withPersistedOmniboxSurface_visible__Vbsay"};